import createCachedSelector from 're-reselect'
import { diff } from 'util/date'
import {
  calculateProrataAmount,
  getPastTimestamp,
  getFutureTimestamp,
  pricingIdToComponents,
} from '../util'
import { selectQuantityForPricingId } from './selectQuantityForPricingId'
import { selectNextBillDate } from './selectNextBillDate'
import { selectPlans } from './selectPlans'
import { selectCurrentBillingCycle } from './selectCurrentBillingCycle'

export const selectUpgradeBreakdown = createCachedSelector(
  (_state, currentPricingId) => currentPricingId,
  (_state, _currentPricingId, newPricingId) => newPricingId,
  (_state, _currentPricingId, _newPricingId, upgradeAt) => upgradeAt,
  selectQuantityForPricingId,
  selectPlans,
  selectNextBillDate,
  selectCurrentBillingCycle,
  (
    currentPricingId,
    newPricingId,
    upgradeAt,
    quantity,
    plans,
    currentCycleEndAtSeconds,
    currentBillingCycle
  ) => {
    const currentCycleEndAt = currentCycleEndAtSeconds * 1000
    const {
      product: currentProduct,
      planId: currentPlanId,
      cycle: currentCycle,
    } = pricingIdToComponents(currentPricingId)
    const {
      product: newProduct,
      planId: newPlanId,
      cycle: newCycle,
    } = pricingIdToComponents(newPricingId)

    const currentPlan = plans.find(
      p => p.product === currentProduct && p.planId === currentPlanId
    )
    const newPlan = plans.find(
      p => p.product === newProduct && p.planId === newPlanId
    )

    const currentCycleMonthlyPrice =
      currentCycle === 'monthly'
        ? currentPlan.monthlyPrice / 100
        : currentPlan.annualPrice / 100 / 12
    const newCycleMonthlyPrice =
      newCycle === 'monthly'
        ? newPlan.monthlyPrice / 100
        : newPlan.annualPrice / 100 / 12

    const currentCycleStart = getPastTimestamp(
      currentCycleEndAt,
      currentBillingCycle
    )
    const nextCycleEnd = getFutureTimestamp(currentCycleStart, newCycle)

    const prorataRefund =
      calculateProrataAmount(
        currentCycleMonthlyPrice,
        upgradeAt,
        currentCycleEndAt
      ) * quantity

    const refundDays = diff('days', upgradeAt, currentCycleEndAt)

    const prorataCharge =
      calculateProrataAmount(newCycleMonthlyPrice, upgradeAt, nextCycleEnd) *
      quantity

    const chargeDays = diff('days', upgradeAt, nextCycleEnd)

    return {
      currentPricingId,
      newPricingId,
      refundDays,
      quantity,
      prorataRefund: Math.round(prorataRefund) * 100,
      prorataCharge: Math.round(prorataCharge) * 100,
      chargeDays,
    }
  }
)((_state, currentPricingId, newPricingId, upgradeAt) =>
  [currentPricingId, newPricingId, upgradeAt].join('-')
)
